import { gql } from "@apollo/client";

export const roleState = {
  role: "",
  description: "",

  roleStatus: "unchecked",
  descriptionStatus: "unchecked",
};

export const roleStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "role": {
      if (value) {
        return {
          ...state,
          role: value,
          roleStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          role: "",
          roleStatus: "unchecked",
        };
      }
    }
    case "description": {
      const alphaNLenghthRegex = new RegExp("^(.{1,50})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          description: value,
          descriptionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          description: "",
          descriptionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          description: value,
          descriptionStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};

export const createRole = gql`
  mutation CreateRole($input: RolesCreateInput!) {
    createRole(input: $input) {
      message
      success
      error
    }
  }
`;

export const updateRole = gql`
  mutation UpdateRole($input: RolesUpdateInput!) {
    updateRole(input: $input) {
      message
      success
      error
    }
  }
`;

export const allRoles = gql`
  query allRoles {
    allRoles {
      data {
        id
        role
        description
      }
      success
      error
      message
    }
  }
`;

export const deleteRoleById = gql`
  mutation DeleteRole($roleId: ID!) {
    deleteRole(roleId: $roleId) {
      success
      error
      message
      data
    }
  }
`;